
import createHeaders from "@utils/createHeaders";

export const headers = createHeaders([
  { text: 'No', align: 'start', value: 'number_index', width: '10' },
  { text: '', value: 'custom', width: '100' },
  { text: 'Nama Merchant / Aggregator', value: 'merchant_name', width: '300'},
  { text: 'MID', value: 'mid'},
  { text: 'Email', value: 'email', width: '300'},
  { text: 'Kode Pos', value: 'postal_code'},
]);

export const search = {
  merchant_name: '',
  mid: '',
  email: '',
  postal_code: '',
};

